/* eslint-disable */
import { contactsImage } from './images'


export const theDarkTheme = {
    type: 'dark',
    primary: '#64748B', //botones y subtitulos
    secondary: '#F8FAFC', //fondo principal
    tertiary: '#efefef', //letra
    quaternary: '#F1F5F9', //fondo de cartas y secundario
    quaternaryLight: '#FFE3B3',
    quinary: '#333',
    septenary: "#334155",
    buttonColor: '#4097AA', //botones de contacto
    contactsimg: contactsImage,
}
